import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import "../../Admin1/Pages/admin1.css";
import heloicon from "../../../safreeimg/superadminimg/heloicon.png";
import Loader from "../../../safreeimg/loader.gif";
import addbtn from "../../../safreeimg/addbtn.png";

const OrgGroupManagement = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    groupId: "",
  });

  const rowsPerPage = 10;
  const navigate = useNavigate();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("No authentication token found");
        setLoading(false);
        return;
      }

      const response = await axios.get(
        "https://api.safree.org/api-v2022/organization/auth/v1/organization-groups",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setUsers(response.data.data);
      } else {
        setError("Failed to fetch users");
      }
    } catch (err) {
      setError("An error occurred while fetching users: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleEditGroup = (user) => {
    setFormData({
      name: user.name || "",
      description: user.description || "",
      groupId: user.groupId || "",
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data Being Sent:", formData);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Authentication token is missing. Please log in again.");
        return;
      }

      const response = await axios.post(
        "https://api.safree.org/api-v2022/organization/auth/v1/edit-group",
        formData, 
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        alert("Group updated successfully!");
        setShowForm(false);
        setFormData({ name: "", description: "", groupId: "" });
        fetchData();
      } else {
        alert("Failed to update group. Please try again.");
      }
    } catch (err) {
      console.error("Error updating group:", err);
      alert(`An error occurred while updating the group: ${err.message}`);
    }
  };

  const totalPages = Math.ceil(users.length / rowsPerPage);
  const currentRows = users.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === "next" && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleViewGroupDetail = (userId) => {
    navigate(`../orgGroupManagement/orgGroupViewDetail/#${userId}`);
  };

  const handleViewSubGroup = (userId, name) => {
  const encodedName = encodeURIComponent(name); // encode to handle spaces or special characters
  navigate(`../orgGroupManagement/orgSubGroupViewDetails/#${userId}/#${encodedName}`);
};


  const handleDeleteGroup = async (groupId) => {
    console.log('Attempting to delete group with ID:', groupId);  // Log groupId

    const confirmation = window.confirm('Are you sure you want to delete this Group?');
    console.log('User confirmation:', confirmation);  // Log confirmation result

    if (!confirmation) return;

    try {
      const token = localStorage.getItem('token');
      console.log('Retrieved token:', token);  // Log the token

      if (!token) {
        alert('Authentication token is missing. Please log in again.');
        return;
      }

      setLoading(true);

      const response = await axios.delete(
        `https://api.safree.org/api-v2022/organization/auth/v1/delete-group/${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('API Response:', response.data);  // Log the API response

      if (response.data.success) {
        alert('Group deleted successfully.');
        setUsers(users.filter((user) => user.groupId !== groupId));
        console.log('Updated user list after deletion:', users);  // Log updated user list
      } else {
        alert('Failed to delete the Group. Please try again.');
        console.log('Failed to delete group:', response.data);  // Log failure response
      }
    } catch (err) {
      console.error('Error deleting group:', err);
      alert(`An error occurred while deleting the user: ${err.message}`);
      console.error('Error details:', err);  // Log detailed error
    } finally {
      setLoading(false);
      console.log('Loading state set to false');  // Log when loading state is set to false
    }
  };


  if (loading) return <div className="loading"><img src={Loader} alt="" /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading">Group Management</p>
        </div>
        <div className="col-md-6 hedrcol2">
          <h3>
            <Link to="/admin2/orgGroupManagement/orgAddNewGroup">Add New Group <img src={addbtn} alt="" /></Link>
          </h3>
        </div>
      </div>

      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th>S. No</th>
              <th>Group Name</th>
              <th>Description</th>
              <th>Members</th>
              <th>SubGroup Details</th>
              <th>Edit Group</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((user, index) => (
              <tr key={index}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>{user.name}</td>
                <td>{user.description}</td>
                <td>
                  <button className="btn btn-view" onClick={() => handleViewGroupDetail(user.groupId)}>
                    View Details
                  </button>
                </td>
                <td>
                  <button className="btn btn-view" onClick={() => handleViewSubGroup(user.groupId, user.name)}>
                    View Details
                  </button>
                </td>
                <td>
                  <button className="btn btn-view" onClick={() => handleEditGroup(user)}>
                    Edit
                  </button>
                </td>
                <td>
                  <button className="btn btn-view"
                    onClick={() => handleDeleteGroup(user.groupId)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="pagination-container">
          <button className="pagination-btn" onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>
            &laquo; Prev
          </button>
          <button className="pagination-btn" onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>
            Next &raquo;
          </button>
        </div>
      </div>

      {showForm && (
        <div className="side-form orgeusercret show">
          <form onSubmit={handleSubmit}>
            <h3>Edit Group</h3>
            <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleInputChange} required />
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              required
              rows="5"
            ></textarea>
            <button type="submit" className="btn-save">Save Details</button>
            <button type="button" className="btn-cancel" onClick={() => setShowForm(false)}>Cancel</button>
          </form>
        </div>
      )}
    </div>
  );
};

export default OrgGroupManagement;
